// This file is automatically generated. Do not edit manually.

import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartMassUpdateApi {
	export async function updateParts(args: { fileHandle: FrontendUploadFileHandle }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productManagement/catalogPart/massUpdate/updateParts",
			method: "POST",
			data: {
				fileHandle: args.fileHandle,
			},
		});
		return response as void;
	}
}
